export default __webpack_public_path__ + "static/media/profile-pic.ced708a4.svg";